/**
 * Exercise Library
 * Source: https://github.com/yuhonas/free-exercise-db (Public Domain)
 * Curated list of common exercises with muscle groups
 */

export const EXERCISES = [
  // === CHEST ===
  { name: "Bench Press", muscle: "chest", equipment: "barbell", level: "beginner" },
  { name: "Barbell Bench Press", muscle: "chest", equipment: "barbell", level: "beginner" },
  { name: "Incline Bench Press", muscle: "chest", equipment: "barbell", level: "intermediate" },
  { name: "Decline Bench Press", muscle: "chest", equipment: "barbell", level: "intermediate" },
  { name: "Dumbbell Bench Press", muscle: "chest", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Press", muscle: "chest", equipment: "dumbbell", level: "beginner" },
  { name: "Incline Dumbbell Press", muscle: "chest", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Fly", muscle: "chest", equipment: "dumbbell", level: "beginner" },
  { name: "Incline Dumbbell Fly", muscle: "chest", equipment: "dumbbell", level: "beginner" },
  { name: "Cable Crossover", muscle: "chest", equipment: "cable", level: "intermediate" },
  { name: "High Cable Crossover", muscle: "chest", equipment: "cable", level: "intermediate" },
  { name: "Cable Fly", muscle: "chest", equipment: "cable", level: "beginner" },
  { name: "Chest Press Machine", muscle: "chest", equipment: "machine", level: "beginner" },
  { name: "Pec Deck Machine", muscle: "chest", equipment: "machine", level: "beginner" },
  { name: "Pectoral Fly Machine", muscle: "chest", equipment: "machine", level: "beginner" },
  { name: "Push-Up", muscle: "chest", equipment: "bodyweight", level: "beginner" },
  { name: "Dips", muscle: "chest", equipment: "bodyweight", level: "intermediate" },

  // === BACK ===
  { name: "Deadlift", muscle: "back", equipment: "barbell", level: "intermediate" },
  { name: "Barbell Row", muscle: "back", equipment: "barbell", level: "intermediate" },
  { name: "T-Bar Row", muscle: "back", equipment: "barbell", level: "intermediate" },
  { name: "Lat Pulldown", muscle: "back", equipment: "cable", level: "beginner" },
  { name: "Front Pulldown Machine", muscle: "back", equipment: "machine", level: "beginner" },
  { name: "Seated Cable Row", muscle: "back", equipment: "cable", level: "beginner" },
  { name: "One Arm Dumbbell Row", muscle: "back", equipment: "dumbbell", level: "beginner" },
  { name: "Incline Dumbbell Row", muscle: "back", equipment: "dumbbell", level: "intermediate" },
  { name: "Dumbbell Pullover", muscle: "back", equipment: "dumbbell", level: "intermediate" },
  { name: "Pull-Up", muscle: "back", equipment: "bodyweight", level: "intermediate" },
  { name: "Pull Up Machine", muscle: "back", equipment: "machine", level: "beginner" },
  { name: "Chin-Up", muscle: "back", equipment: "bodyweight", level: "intermediate" },
  { name: "Seated Row Machine", muscle: "back", equipment: "machine", level: "beginner" },
  { name: "Back Extension Machine", muscle: "back", equipment: "machine", level: "beginner" },
  { name: "Straight Arm Pulldown", muscle: "back", equipment: "cable", level: "beginner" },
  { name: "Face Pull", muscle: "back", equipment: "cable", level: "beginner" },

  // === SHOULDERS ===
  { name: "Overhead Press", muscle: "shoulders", equipment: "barbell", level: "intermediate" },
  { name: "Seated Barbell Press", muscle: "shoulders", equipment: "barbell", level: "intermediate" },
  { name: "Dumbbell Shoulder Press", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Arnold Press", muscle: "shoulders", equipment: "dumbbell", level: "intermediate" },
  { name: "Lateral Raise", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Lateral Raise", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Seated Dumbbell Lateral Raise", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Front Raise", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Seated Dumbbell Front Raise", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Cable Rope Front Raise", muscle: "shoulders", equipment: "cable", level: "beginner" },
  { name: "Rear Delt Fly", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Rear Deltoid Fly", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },
  { name: "Cable Rear Deltoid Fly", muscle: "shoulders", equipment: "cable", level: "beginner" },
  { name: "Cable Lateral Raise", muscle: "shoulders", equipment: "cable", level: "beginner" },
  { name: "Cable Front Raise", muscle: "shoulders", equipment: "cable", level: "beginner" },
  { name: "Reverse Pec Deck", muscle: "shoulders", equipment: "machine", level: "beginner" },
  { name: "Rear Deltoid Fly Machine", muscle: "shoulders", equipment: "machine", level: "beginner" },
  { name: "Shoulder Press Machine", muscle: "shoulders", equipment: "machine", level: "beginner" },
  { name: "Upright Row", muscle: "shoulders", equipment: "barbell", level: "intermediate" },
  { name: "Shrugs", muscle: "shoulders", equipment: "dumbbell", level: "beginner" },

  // === BICEPS ===
  { name: "Barbell Curl", muscle: "biceps", equipment: "barbell", level: "beginner" },
  { name: "EZ Bar Curl", muscle: "biceps", equipment: "barbell", level: "beginner" },
  { name: "Preacher Curl", muscle: "biceps", equipment: "barbell", level: "beginner" },
  { name: "Dumbbell Curl", muscle: "biceps", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Biceps Curl", muscle: "biceps", equipment: "dumbbell", level: "beginner" },
  { name: "Hammer Curl", muscle: "biceps", equipment: "dumbbell", level: "beginner" },
  { name: "Concentration Curl", muscle: "biceps", equipment: "dumbbell", level: "beginner" },
  { name: "Incline Dumbbell Curl", muscle: "biceps", equipment: "dumbbell", level: "intermediate" },
  { name: "Incline Dumbbell Biceps Curl", muscle: "biceps", equipment: "dumbbell", level: "intermediate" },
  { name: "Cable Curl", muscle: "biceps", equipment: "cable", level: "beginner" },
  { name: "Cable Biceps Curl", muscle: "biceps", equipment: "cable", level: "beginner" },
  { name: "Cable Hammer Curl", muscle: "biceps", equipment: "cable", level: "beginner" },
  { name: "Machine Bicep Curl", muscle: "biceps", equipment: "machine", level: "beginner" },
  { name: "Biceps Curl Machine", muscle: "biceps", equipment: "machine", level: "beginner" },

  // === TRICEPS ===
  { name: "Close Grip Bench Press", muscle: "triceps", equipment: "barbell", level: "intermediate" },
  { name: "Skull Crusher", muscle: "triceps", equipment: "barbell", level: "intermediate" },
  { name: "Tricep Pushdown", muscle: "triceps", equipment: "cable", level: "beginner" },
  { name: "Cable Triceps Pushdown", muscle: "triceps", equipment: "cable", level: "beginner" },
  { name: "Rope Pushdown", muscle: "triceps", equipment: "cable", level: "beginner" },
  { name: "Overhead Tricep Extension", muscle: "triceps", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Kickback", muscle: "triceps", equipment: "dumbbell", level: "beginner" },
  { name: "Tricep Dips", muscle: "triceps", equipment: "bodyweight", level: "intermediate" },
  { name: "Bench Dips", muscle: "triceps", equipment: "bodyweight", level: "beginner" },
  { name: "Cable Overhead Extension", muscle: "triceps", equipment: "cable", level: "beginner" },
  { name: "Tricep Press Machine", muscle: "triceps", equipment: "machine", level: "beginner" },
  { name: "Triceps Press Machine", muscle: "triceps", equipment: "machine", level: "beginner" },

  // === LEGS (Quadriceps) ===
  { name: "Squat", muscle: "quadriceps", equipment: "bodyweight", level: "beginner" },
  { name: "Barbell Squat", muscle: "quadriceps", equipment: "barbell", level: "intermediate" },
  { name: "Front Squat", muscle: "quadriceps", equipment: "barbell", level: "intermediate" },
  { name: "Leg Press", muscle: "quadriceps", equipment: "machine", level: "beginner" },
  { name: "Leg Press Machine", muscle: "quadriceps", equipment: "machine", level: "beginner" },
  { name: "Leg Extension", muscle: "quadriceps", equipment: "machine", level: "beginner" },
  { name: "Hack Squat", muscle: "quadriceps", equipment: "machine", level: "intermediate" },
  { name: "Goblet Squat", muscle: "quadriceps", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Sumo Squat", muscle: "quadriceps", equipment: "dumbbell", level: "beginner" },
  { name: "Dumbbell Lunge", muscle: "quadriceps", equipment: "dumbbell", level: "beginner" },
  { name: "Walking Lunge", muscle: "quadriceps", equipment: "dumbbell", level: "intermediate" },
  { name: "Bulgarian Split Squat", muscle: "quadriceps", equipment: "dumbbell", level: "intermediate" },
  { name: "Step Up", muscle: "quadriceps", equipment: "dumbbell", level: "beginner" },
  { name: "Sissy Squat", muscle: "quadriceps", equipment: "bodyweight", level: "intermediate" },
  { name: "Adductor", muscle: "quadriceps", equipment: "machine", level: "beginner" },
  { name: "Abductor", muscle: "quadriceps", equipment: "machine", level: "beginner" },

  // === LEGS (Hamstrings) ===
  { name: "Romanian Deadlift", muscle: "hamstrings", equipment: "barbell", level: "intermediate" },
  { name: "Barbell Romanian Deadlift", muscle: "hamstrings", equipment: "barbell", level: "intermediate" },
  { name: "Stiff Leg Deadlift", muscle: "hamstrings", equipment: "barbell", level: "intermediate" },
  { name: "Leg Curl", muscle: "hamstrings", equipment: "machine", level: "beginner" },
  { name: "Seated Leg Curl", muscle: "hamstrings", equipment: "machine", level: "beginner" },
  { name: "Good Morning", muscle: "hamstrings", equipment: "barbell", level: "intermediate" },
  { name: "Dumbbell Romanian Deadlift", muscle: "hamstrings", equipment: "dumbbell", level: "beginner" },
  { name: "Nordic Curl", muscle: "hamstrings", equipment: "bodyweight", level: "expert" },

  // === LEGS (Glutes) ===
  { name: "Hip Thrust", muscle: "glutes", equipment: "barbell", level: "intermediate" },
  { name: "Barbell Hip Thrust", muscle: "glutes", equipment: "barbell", level: "intermediate" },
  { name: "Glute Bridge", muscle: "glutes", equipment: "barbell", level: "beginner" },
  { name: "Cable Kickback", muscle: "glutes", equipment: "cable", level: "beginner" },
  { name: "Hip Abduction Machine", muscle: "glutes", equipment: "machine", level: "beginner" },
  { name: "Sumo Squat", muscle: "glutes", equipment: "dumbbell", level: "beginner" },
  { name: "Donkey Kick", muscle: "glutes", equipment: "bodyweight", level: "beginner" },

  // === LEGS (Calves) ===
  { name: "Calf Raise", muscle: "calves", equipment: "machine", level: "beginner" },
  { name: "Standing Calf Raise", muscle: "calves", equipment: "machine", level: "beginner" },
  { name: "Seated Calf Raise", muscle: "calves", equipment: "machine", level: "beginner" },
  { name: "Donkey Calf Raise", muscle: "calves", equipment: "machine", level: "intermediate" },
  { name: "Leg Press Calf Raise", muscle: "calves", equipment: "machine", level: "beginner" },

  // === CORE (Abdominals) ===
  { name: "Crunch", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Sit-Up", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Plank", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Side Plank", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Leg Raise", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Hanging Leg Raise", muscle: "abdominals", equipment: "bodyweight", level: "intermediate" },
  { name: "Russian Twist", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Cable Crunch", muscle: "abdominals", equipment: "cable", level: "beginner" },
  { name: "Cable Rope Crunch", muscle: "abdominals", equipment: "cable", level: "beginner" },
  { name: "Cable oblique twist", muscle: "abdominals", equipment: "cable", level: "beginner" },
  { name: "Ab Wheel Rollout", muscle: "abdominals", equipment: "other", level: "intermediate" },
  { name: "Mountain Climber", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },
  { name: "Bicycle Crunch", muscle: "abdominals", equipment: "bodyweight", level: "beginner" },

  // === CARDIO ===
  { name: "Running", muscle: "cardio", equipment: "none", level: "beginner", category: "cardio" },
  { name: "Walking", muscle: "cardio", equipment: "none", level: "beginner", category: "cardio" },
  { name: "Treadmill", muscle: "cardio", equipment: "machine", level: "beginner", category: "cardio" },
  { name: "Stationary Bike", muscle: "cardio", equipment: "machine", level: "beginner", category: "cardio" },
  { name: "Elliptical", muscle: "cardio", equipment: "machine", level: "beginner", category: "cardio" },
  { name: "Rowing Machine", muscle: "cardio", equipment: "machine", level: "beginner", category: "cardio" },
  { name: "Stair Climber", muscle: "cardio", equipment: "machine", level: "beginner", category: "cardio" },
  { name: "Jump Rope", muscle: "cardio", equipment: "other", level: "beginner", category: "cardio" },
  { name: "Burpees", muscle: "cardio", equipment: "bodyweight", level: "intermediate", category: "cardio" },
  { name: "Jumping Jacks", muscle: "cardio", equipment: "bodyweight", level: "beginner", category: "cardio" },
  { name: "Box Jumps", muscle: "cardio", equipment: "other", level: "intermediate", category: "cardio" },
  { name: "Battle Ropes", muscle: "cardio", equipment: "other", level: "intermediate", category: "cardio" },
  { name: "Swimming", muscle: "cardio", equipment: "none", level: "beginner", category: "cardio" },
  { name: "Cycling", muscle: "cardio", equipment: "other", level: "beginner", category: "cardio" },

  // === FLEXIBILITY/STRETCHING ===
  { name: "Yoga", muscle: "flexibility", equipment: "none", level: "beginner", category: "flexibility" },
  { name: "Stretching", muscle: "flexibility", equipment: "none", level: "beginner", category: "flexibility" },
  { name: "Foam Rolling", muscle: "flexibility", equipment: "other", level: "beginner", category: "flexibility" },
  { name: "Pilates", muscle: "flexibility", equipment: "none", level: "beginner", category: "flexibility" },

  // === SPORTS ===
  { name: "Basketball", muscle: "sport", equipment: "none", level: "beginner", category: "sport" },
  { name: "Football", muscle: "sport", equipment: "none", level: "beginner", category: "sport" },
  { name: "Tennis", muscle: "sport", equipment: "other", level: "beginner", category: "sport" },
  { name: "Badminton", muscle: "sport", equipment: "other", level: "beginner", category: "sport" },
  { name: "Volleyball", muscle: "sport", equipment: "none", level: "beginner", category: "sport" },

  // === KICKBOX ===
  { name: "Kickbox Antrenmanı", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Boks Antrenmanı", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Muay Thai", muscle: "full_body", equipment: "none", level: "intermediate", category: "kickbox" },
  { name: "Shadow Boxing", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Kum Torbası", muscle: "full_body", equipment: "other", level: "beginner", category: "kickbox" },
  { name: "Pençe Çalışması", muscle: "full_body", equipment: "other", level: "beginner", category: "kickbox" },
  { name: "Sparring", muscle: "full_body", equipment: "none", level: "intermediate", category: "kickbox" },
  { name: "Teknik Çalışma", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Kombinasyon Çalışması", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Kondisyon", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Yumruk Kombinasyonları", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Tekme Çalışması", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
  { name: "Diz ve Dirsek Çalışması", muscle: "full_body", equipment: "none", level: "intermediate", category: "kickbox" },
  { name: "Savunma Teknikleri", muscle: "full_body", equipment: "none", level: "beginner", category: "kickbox" },
];

// Muscle group mapping for easier filtering
export const MUSCLE_GROUPS = {
  chest: { label: 'Göğüs' },
  back: { label: 'Sırt' },
  shoulders: { label: 'Omuz' },
  biceps: { label: 'Biceps' },
  triceps: { label: 'Triceps' },
  quadriceps: { label: 'Ön Bacak' },
  hamstrings: { label: 'Arka Bacak' },
  glutes: { label: 'Kalça' },
  calves: { label: 'Baldır' },
  abdominals: { label: 'Karın' },
  cardio: { label: 'Kardiyo' },
  flexibility: { label: 'Esneklik' },
  sport: { label: 'Spor' },
};

// Get exercises by muscle group
export const getExercisesByMuscle = (muscle) => {
  return EXERCISES.filter(e => e.muscle === muscle).map(e => e.name);
};

// Get all exercise names
export const getAllExerciseNames = () => {
  return EXERCISES.map(e => e.name);
};

// Search exercises by name
export const searchExercises = (query) => {
  const q = query.toLowerCase();
  return EXERCISES.filter(e => e.name.toLowerCase().includes(q));
};

// Get exercises by category (fitness, cardio, kickbox)
export const getExercisesByCategory = (category) => {
  if (category === 'fitness') {
    // Fitness exercises are those without a category field (strength training)
    return EXERCISES.filter(e => !e.category).map(e => e.name);
  }
  return EXERCISES.filter(e => e.category === category).map(e => e.name);
};

// Get muscle group for an exercise name
export const getMuscleForExercise = (exerciseName) => {
  if (!exerciseName) return null;

  // First try exact match
  const exactMatch = EXERCISES.find(e =>
    e.name.toLowerCase() === exerciseName.toLowerCase()
  );
  if (exactMatch) return exactMatch.muscle;

  // Try partial match
  const partialMatch = EXERCISES.find(e =>
    exerciseName.toLowerCase().includes(e.name.toLowerCase()) ||
    e.name.toLowerCase().includes(exerciseName.toLowerCase())
  );
  if (partialMatch) return partialMatch.muscle;

  // Keyword-based inference
  const lowerName = exerciseName.toLowerCase();

  // Chest keywords
  if (lowerName.includes('bench') || lowerName.includes('chest') || lowerName.includes('pec') ||
      lowerName.includes('göğüs') || lowerName.includes('fly') || lowerName.includes('push-up') ||
      lowerName.includes('pushup')) {
    return 'chest';
  }

  // Back keywords
  if (lowerName.includes('row') || lowerName.includes('pulldown') || lowerName.includes('deadlift') ||
      lowerName.includes('pull-up') || lowerName.includes('pullup') || lowerName.includes('lat') ||
      lowerName.includes('sırt') || lowerName.includes('back')) {
    return 'back';
  }

  // Shoulder keywords
  if (lowerName.includes('shoulder') || lowerName.includes('lateral') || lowerName.includes('deltoid') ||
      lowerName.includes('omuz') || lowerName.includes('rear delt') || lowerName.includes('front raise') ||
      lowerName.includes('facepull') || lowerName.includes('face pull') ||
      (lowerName.includes('raise') && !lowerName.includes('calf') && !lowerName.includes('leg'))) {
    return 'shoulders';
  }

  // Biceps keywords
  if (lowerName.includes('bicep') || lowerName.includes('curl') || lowerName.includes('hammer')) {
    return 'biceps';
  }

  // Triceps keywords
  if (lowerName.includes('tricep') || lowerName.includes('pushdown') || lowerName.includes('skull') ||
      lowerName.includes('kickback') || lowerName.includes('dip')) {
    return 'triceps';
  }

  // Leg keywords
  if (lowerName.includes('squat') || lowerName.includes('leg') || lowerName.includes('lunge') ||
      lowerName.includes('extension') || lowerName.includes('quad') || lowerName.includes('bacak') ||
      lowerName.includes('abductor') || lowerName.includes('adductor')) {
    return 'quadriceps';
  }

  // Hamstring/Glute keywords
  if (lowerName.includes('hamstring') || lowerName.includes('glute') || lowerName.includes('hip') ||
      lowerName.includes('romanian') || lowerName.includes('kalça')) {
    return 'hamstrings';
  }

  // Calf keywords
  if (lowerName.includes('calf') || lowerName.includes('calves') || lowerName.includes('baldır')) {
    return 'calves';
  }

  // Abs keywords
  if (lowerName.includes('abs') || lowerName.includes('crunch') || lowerName.includes('plank') ||
      lowerName.includes('karın') || lowerName.includes('core') || lowerName.includes('abdominal') ||
      lowerName.includes('oblique') || lowerName.includes('twist') || lowerName.includes('sit-up') ||
      lowerName.includes('situp')) {
    return 'abdominals';
  }

  return null;
};
